export default __webpack_public_path__ + "static/rabo-mono-907a14df1303346c3c2e592d1f37da83d2435364322be3d120eecf7ec015afee.svg";